<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Hunting Period</p>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="setHuntingPeriodDates">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">From</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <FlatPickr v-model="from" :config="dateConfig" class="input" />
                </div>
              </div>
            </div>
          </div>

          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">To</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <FlatPickr v-model="to" :config="dateConfig" class="input" />
                </div>
              </div>
            </div>
          </div>

          <input type="submit" style="display: none" />
        </form>

        <!-- Error notification section -->
        <div class="notification is-danger" v-if="error">
          {{ error }}
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="container">
          <div class="is-pulled-right">
            <button class="button" @click="cancel">
              Cancel
            </button>
            <button class="button is-primary" @click="setHuntingPeriodDates">
              OK
            </button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import FlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: 'AnimalEditHuntingPeriodModal',

  components: { FlatPickr },

  props: {
    animalsStorePath: {
      type: String,
      required: true
    },

    huntingPeriod: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      from: null,
      to: null,
      error: null
    }
  },

  mounted() {
    this.from = this.huntingPeriod.from
    this.to = this.huntingPeriod.to
  },

  computed: {
    dateConfig() {
      return {
        weekNumbers: true,
        dateFormat: 'Y-m-d',
        locale: {
          firstDayOfWeek: 1
        }
      }
    }
  },

  methods: {
    cancel() {
      this.$emit('cancelled')
    },

    async setHuntingPeriodDates() {
      if (this.from > this.to) {
        this.error = 'From cannot be later than To'
        return
      }

      this.error = null

      this.huntingPeriod.from = this.from
      this.huntingPeriod.to = this.to

      this.$emit('succeeded')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card-head {
  border-bottom: 0;
}

.modal-card-foot {
  border-top: 0;
}

.notification {
  margin-top: 1em;
}
</style>
